import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-702e55e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-ter" }
const _hoisted_2 = ["onClick"]

import { computed } from 'vue'
import { t } from '@/plugins/i18n'
import ImgTooltip from '@/components/common/ImgTooltip.vue'
import UploadImg from '@/components/common/UploadImg.vue'
import { BASE_IMAGE } from '@/common/baseImage'


export default /*#__PURE__*/_defineComponent({
  props: ['img', 'list', 'orderFlag'],
  emits: ['update:img'],
  setup(__props, { emit }) {

const props = __props

const imgs: any = computed(() =>
  [
    ...new Set(props.list.map((v: any) => v.productSkuImg || v.productMainImg || BASE_IMAGE))
  ].slice(0, 5)
)
const force = imgs.value.includes(props.img)
console.log(force)


const checkOrderFlag = (event:MouseEvent) => {
  if (props.orderFlag) {
    event.stopPropagation()
    event.preventDefault
      ? event.preventDefault()
      : (event.returnValue = false)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock(_component_el_form_item, {
    prop: "combinationProductMainImg",
    label: _unref(t)('组合图片'),
    onClickCapture: checkOrderFlag
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imgs), (v) => {
          return (_openBlock(), _createElementBlock("div", {
            key: v,
            class: _normalizeClass(["main-img mr_10 btn", { active: v === __props.img }]),
            onClick: ($event: any) => (emit('update:img', v))
          }, [
            _createVNode(ImgTooltip, {
              src: v,
              class: "pt_img",
              height: "160px"
            }, null, 8, ["src"])
          ], 10, _hoisted_2))
        }), 128))
      ]),
      _createVNode(UploadImg, {
        onChange: _cache[0] || (_cache[0] = (v) => emit('update:img', v)),
        img: __props.img,
        force: _unref(force)
      }, null, 8, ["img", "force"])
    ]),
    _: 1
  }, 8, ["label"]))
}
}

})